var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$showAd() && _vm.$isMoe() ? _c('div', [_vm.type == 'feed' ? _c('InFeedAdsense', {
    attrs: {
      "data-ad-layout-key": "-fg+6d-1m-er+wm",
      "data-ad-client": "ca-pub-7892650861805139",
      "data-ad-slot": "3136351268"
    }
  }) : _vm._e(), _vm.type == 'display' ? _c('Adsense', {
    attrs: {
      "data-ad-layout-key": "auto",
      "data-ad-client": "ca-pub-7892650861805139",
      "data-ad-slot": "9264653959"
    }
  }) : _vm._e()], 1) : _vm.$isDev() ? _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-content', [_c('v-list-item-subtitle', {
    staticClass: "text-center my-8"
  }, [_vm._v("Ad: " + _vm._s(_vm.type))])], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }